/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SequentiallyBetWayInitialWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/initial/sequentially/SequentiallyBetWayInitialWPController";
import {Timeline, TimelineLite} from "gsap";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneReelSymbol} from "../../symbols/TombstoneReelSymbol";
import {TombstoneWildSymbol} from "../../symbols/TombstoneWildSymbol";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import {WinWaysIndicator} from "../winways/WinWaysIndicator";
import {TombstoneInitialWinCountUp} from "./TombstoneInitialWinCountUp";
import {TombstoneInitialWPView} from "./TombstoneInitialWPView";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";
import {TombstoneNoMercy} from "../../TombstoneNoMercy";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";

export class TombstoneInitialWPController extends SequentiallyBetWayInitialWPController {

    private _symbolDelay:number = 0.1;
    private _betWayDelay:number = 0.5;

    private _gameView:TombstoneInitialWPView;
    private _winCountUp:TombstoneInitialWinCountUp;
    private _tombstoneData:TombstoneParsedGameData;

    private _winWaysWon:number = 0;
    private _belowStakeWinRestriction:boolean;
    private _winTextPosition:PIXI.Point;

    constructor(indexes:[number, number]) {
        super(indexes);

        this._gameView = new TombstoneInitialWPView();
        this._winCountUp = new TombstoneInitialWinCountUp();
        this._winCountUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.5);
        StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        if(super.parseFeatureGameData) {
            super.parseFeatureGameData(data);
        }

        this._tombstoneData = data;

        // #277
        this._belowStakeWinRestriction = TombstoneGameConfig.instance.WIN_BELOW_STAKE = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction &&  TombstoneGameModuleConfig.gameData.isWinBelowStake());
    }

    private getWinTextPosition(reelWinPositions:boolean[][]):PIXI.Point {
        for(let reelId = reelWinPositions.length - 1; reelId >= 0; reelId--) {
            for(let symId = 0; symId < 3; symId++) {
                if(reelWinPositions[reelId][symId] && !Reels.getSymbol(reelId, symId)?.symName.includes("W")) {
                    return new PIXI.Point(reelId, symId);
                }
            }
        }
        return new PIXI.Point(0, reelWinPositions[0].indexOf(true));
    }

    protected addSingleBetWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number):number {
        if(this._belowStakeWinRestriction) {
            startTime = 0;
        }
        this._winTextPosition = this.getWinTextPosition(betWayWinData.reelWinPositions);
        const delay:number = super.addSingleBetWinAnimationToTimeline(betWayWinData, timeline, startTime);

        this._winWaysWon += betWayWinData.numberOfCombinations;
        const winWaysWon = this._winWaysWon;

        timeline.add(() => {EventHandler.dispatchEvent(new GameEvent(WinWaysIndicator.SHOW_WIN_WAYS_WON, winWaysWon))}, startTime + delay);

        //return delay + this._betWayDelay;
        return delay + (this._belowStakeWinRestriction ? 0.01 : this._betWayDelay);
    }

    protected addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, symbol:TombstoneReelSymbol, reelId:number, symbolId:number):number {
        if(this._belowStakeWinRestriction) {
            return 0;
        }

        const position:[number, number] = Helper.getSymbolPositions(reelId, symbolId);
        const symbolDuration:number = super.addSymbolWinAnimationToTimeline(betWayWinData, timeline, startTime, symbol, reelId, symbolId);
        if(reelId === this._winTextPosition.x && symbolId === this._winTextPosition.y) {
            this._gameView.addWinNumberToTimeline(timeline, startTime, position, symbol, betWayWinData);
        }
        if(symbol.symName.indexOf("W") === -1) {
            this._gameView.addWinSparkToTimeline(timeline, startTime, position);

            // #277
            if (!TombstoneGameModuleConfig.gameData.isWinBelowStake()) {
                timeline.add(() => SlotGame.sound.playEffect(TombstoneSoundConfig.getPistolSoundName()), startTime);
            }
        } else {
            const numSpark:number = Math.ceil(Math.random() * 2);
            for(let i:number = 0; i < numSpark; i++) {
                const offsetX:number = Math.round(Math.random() * (GameConfig.instance.SYMBOL_WIDTH - 20)) - GameConfig.instance.SYMBOL_WIDTH / 2 + 10;
                const offsetY:number = Math.round(Math.random() * (GameConfig.instance.SYMBOL_HEIGHT - 20)) - GameConfig.instance.SYMBOL_HEIGHT / 2 + 10;
                const time:number = startTime + i * symbolDuration / numSpark;
                this._gameView.addWinSparkToTimeline(timeline, time, [position[0] + offsetX, position[1] + offsetY]);
                this._gameView.addWildHoleSmoke(timeline, time, [position[0] + offsetX, position[1] + offsetY]);
                timeline.add(() => (<TombstoneWildSymbol>symbol).addHole(symbolId, offsetX, offsetY), time + 0.05);

                // #277
                if (!TombstoneGameModuleConfig.gameData.isWinBelowStake()) {
                    timeline.add(() => SlotGame.sound.playEffect(TombstoneSoundConfig.getPistolSoundName()), time);
                }
            }
        }

        return this._symbolDelay;
    }

    protected addWinCountUpToTimeline(timeline:Timeline):void {
        if(this._gameData!.isBigWin) {
            return;
        }

        /*if(this._belowStakeWinRestriction) {

            //SlotGame.winFieldController.showWinField();
            TombstoneNoMercy.keypad.setWin((this._gameData?.mode === GameMode.NORMAL)? this._gameData!.singleWin : (<TombstoneParsedGameData>this._gameData)!.accumulatedRoundWin, (this._gameData?.mode !== GameMode.NORMAL), TombstoneGameModuleConfig.gameData.isWinBelowStake());
            if(TombstoneGameModuleConfig.gameData.isWinBelowStake()) {
                TombstoneNoMercy.keypad.show();
            }
            return;
        }*/

        const duration:number = this._gameData!.currentWinRatioConfig!.duration;
        const countUpTimeline:TimelineLite = new TimelineLite();

        if(!TombstoneGameModuleConfig.gameData.isWinBelowStake() || (TombstoneGameModuleConfig.gameData.mode === "FREESPIN" || TombstoneGameModuleConfig.gameData.mode === "SUPER_FREESPIN")) {
            countUpTimeline.add(this._winCountUp.getCountUpAnimation(0, this._gameData!.singleWin, duration, this._gameData!.currentMultiplier));
        }

        if(!TombstoneGameModuleConfig.gameData.isWinBelowStake()) {
            countUpTimeline.add(() => SlotGame.winFieldController.showWinField());
        }
        if(TombstoneGameModuleConfig.gameData.isWinBelowStake()) {
            countUpTimeline.add(() => {
                TombstoneNoMercy.keypad.setWin((this._gameData?.mode === GameMode.NORMAL)? this._gameData!.singleWin : (<TombstoneParsedGameData>this._gameData)!.accumulatedRoundWin, (this._gameData?.mode !== GameMode.NORMAL), TombstoneGameModuleConfig.gameData.isWinBelowStake());
                if(TombstoneGameModuleConfig.gameData.isWinBelowStake()) {
                    TombstoneNoMercy.keypad.show();
                }
            });
        }

        timeline.add(countUpTimeline, "-=0.4");
    }

    protected startWinPresentation():void {
        super.startWinPresentation();

        const winSound:string | null = TombstoneSoundConfig.getNormalWinSoundName(this._gameData!.currentWinRatioConfig!.type!);
        // #277
        if(winSound && !TombstoneGameModuleConfig.gameData.isWinBelowStake()) {
            SlotGame.sound.playEffect(winSound);
        }

        if(this._gameData!.isBigWin || (<TombstoneParsedGameData>this._gameData).brokeTheBank) {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.BIG_WIN_INITIAL);
            SlotGame.sound.fadeAmbience(0, 500);
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
       //super.stopWinPresentation(isAborted);

        if(this._timeline) {
            if(this._timeline.isActive()) {
                this._timeline.pause();
                this._timeline.kill();
            }
            this._timeline = null;
        }
        while(this._winSymbols.length > 0) {
            const sym = this._winSymbols.pop()! as TombstoneReelSymbol;
            sym.changeState({
                state : GameConfig.instance.SYMBOL_STATES.win,
                frames : [-1, -1]
            });
            if(!this._belowStakeWinRestriction && sym.shouldPlayWinText && !sym.winTextPlayed) { // TODO
                this._gameView.playWinNumberOnPosition(sym.shouldPlayWinText.position, sym, sym.shouldPlayWinText.betWayWinData);
            }
        }

        this._gameView.stopWinPresentation();


        // this._winCountUp.abort(this._gameData!.singleWin, isAborted, this._gameData!.currentMultiplier, this._gameData!.isBigWin);
        if(!this._belowStakeWinRestriction) {
            this._winCountUp.abort(this._gameData!.singleWin, isAborted, this._gameData!.currentMultiplier, this._gameData!.isBigWin);
        }

        EventHandler.dispatchEvent(new GameEvent(WinWaysIndicator.SHOW_WIN_WAYS_WON));
        if(isAborted) {
            if(this._gameData!.isBigWin) {
                SlotGame.sound.fadeAmbience(0, 500);
            } else {
                SlotGame.winFieldController.showWinField();
                if(TombstoneGameModuleConfig.gameData.isWinBelowStake()) {
                    TombstoneNoMercy.keypad.setWin((this._gameData?.mode === GameMode.NORMAL)? this._gameData!.singleWin : (<TombstoneParsedGameData>this._gameData)!.accumulatedRoundWin, (this._gameData?.mode !== GameMode.NORMAL), TombstoneGameModuleConfig.gameData.isWinBelowStake());
                    TombstoneNoMercy.keypad.show();
                }
            }
        }
    }

    public resetFeature():void {
        this._winWaysWon = 0;
    }
}